import $ from 'jquery';

// CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
// ============================================================

function transitionEnd() {
    var name,
        el = document.createElement('asimov'),
        transEndEventNames = {
            'WebkitTransition': 'webkitTransitionEnd',
            'MozTransition': 'transitionend',
            'OTransition': 'oTransitionEnd otransitionend',
            'transition': 'transitionend'
        };

    for (name in transEndEventNames) {
        if (el.style[name] !== undefined) {
            return {
                end: transEndEventNames[name]
            };
        }
    }
}

$.fn.transitionEnd = function(callback) {
    if ($.support.transition) {
        $(this).one($.support.transition.end, callback);
    } else {
        callback.call($(this));
    }

    return this;
};

$(function() {
    $.support.transition = transitionEnd();
});



// WEBPACK FOOTER //
// ./~/@99designs/asimov-modal/lib/transition.js